<h2 class="section-subtitle">
  <a [routerLink]="experienceLink()"> Experience</a>
  <button mat-mini-fab color="primary" (click)="openDialog()">
    <mat-icon>add</mat-icon>
  </button>
</h2>
<div id="experience" class="container">
  @for (experience of character.getExperience(); track experience; let i = $index) {
    <mat-card appearance="outlined">
      <mat-card-content>
        @if (editing!=i) {
          <mat-icon class='experience-edit' color="primary" (click)="editing = i">edit</mat-icon>
        }
        @if (editing!=i) {
          <mat-list dense>
            <h2>Experience Block {{i + 1}}</h2>
            <mat-list-item><span>Class:&nbsp;</span> {{experience.class}} </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item><span>Prime Requisite:&nbsp; </span> {{experience.prime | titlecase}} </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item><span>Bonus Experience:&nbsp;&nbsp;</span> {{experience.bonus_xp}}%</mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item><span>Level:&nbsp; </span> {{experience.currentLevel()}} </mat-list-item>
            <mat-divider></mat-divider>
            @if (experience.currentExperience() > 0) {
              <div class="progress-bar">
                <mat-progress-bar mode="determinate" value="{{experience.levelProgress()*100}}"></mat-progress-bar>
                {{experience.currentExperience()}} / {{experience.totalExperienceForLevel(experience.currentLevel() + 1)}}
                <br/>
                {{experience.levelProgress() | percent:'1.2' }}
              </div>
            }
          </mat-list>
          @if (experience.experiences.length) {
            <table class="print-only experience-history">
              <thead>
                <tr><th>Date</th><th>XP</th><th>Notes</th></tr>
              </thead>
              <tbody>
                @for (entry of experience.experiences; track entry) {
                  <tr>
                    <td class="history-date">{{entry.date | date:'mediumDate'}}</td>
                    <td class="history-points">{{entry.points}}</td>
                    <td>{{entry.notes}}</td>
                  </tr>
                }
                <tr class="history-total">
                  <td>Total</td>
                  <td class="history-points">{{experience.currentExperience()}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          }
        }
        @if (editing==i) {
          <mat-list dense class="editing">
            @if (editing==i&&character.getExperience().length>1) {
              <mat-icon class='experience-edit' color="warn" (click)="confirmDelete(experience)">delete</mat-icon>
            }
            <h2>Experience Block {{i + 1}}</h2>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Class:</mat-label>
                <mat-select [(ngModel)]="experience.class">
                  @for (class of classes; track class) {
                    <mat-option [value]="class">
                      {{class}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Prime Requisite:</mat-label>
                <mat-select [(ngModel)]="experience.prime">
                  @for (prime of abilities; track prime) {
                    <mat-option [value]="prime">
                      {{prime}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <button mat-raised-button color="primary" (click)="doneEditing()">Done</button>
            </mat-list-item>
          </mat-list>
        }
      </mat-card-content>
    </mat-card>
  }
  @if (canAddClass()) {
    <mat-card appearance="outlined" class="new-class">
      <mat-card-content>
        <div class="table">
          <div class="table-cell">
            <button class="add-experience-block" color="primary" mat-mini-fab (click)="addExperienceBlock()">
              <mat-icon>add</mat-icon>
            </button>
            <h1>Add a class</h1>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>

